import React, { useCallback } from 'react';
import * as PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import './Image.css';
import { isUrlAbsolute } from '../../utility/fetch-util';
import { imageLocations } from "./ImageLocations";


function DPImg({ imgSrc, height }) {
  return (
    <img
      className="dp-img"
      src={imgSrc}
      alt=""
      height={height}
    />
  );
}

DPImg.propTypes = {
  imgSrc: PropTypes.string.isRequired,
};


export function BannerImage({ href, imageSrc, style, height, className }) {

  // If there's an href then we want the logo to wrapped in an anchor.
  const Wrapper = useCallback(({ children, ...rest }) => {
    if (href) {
      // Check if the link is going externally. The Link component is only for internal components.
      return isUrlAbsolute(href)
        ? <a href={href} {...rest}>{children}</a>
        : <Link to={href} {...rest}>{children}</Link>;
    }

    return <div {...rest}>{children}</div>;
  }, [href]);

  return (
    <Wrapper style={style} className={`dp-banner-image ${className || ''}`}>
      <DPImg imgSrc={imageSrc} height={height} />
    </Wrapper>
  );
}

BannerImage.propTypes = {
  href: PropTypes.string,
  imageSrc: PropTypes.string,
  style: PropTypes.shape({}), // Any JS-CSS style. Too many to define in a prop type.
  className: PropTypes.string,
};

BannerImage.defaultProps = {
  href: undefined,
  imageSrc: imageLocations.NIGHT_BANNER_IMAGE,
  style: undefined,
  className: undefined,
};
